import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledAnchor = styled.a`
  color: #6200ea;
  text-decoration: underline;
`;

export const StyledLink = styled(Link)`
  color: #6200ea;
  text-decoration: underline;
`;

export const StyledTableWrapper = styled.div`
  background: #ffffff;
  padding: 20px;
`;

export const MainImage = styled.img`
  width: 80px;
  object-fit: contain;
`;

export const ButtonLikeLinkStyle = styled(Link)`
  width: 80px;
  line-height: 36px;
  height: 36px;
  background-color: #6200ea;
  color: #ffffff;
  border-radius: 5px;
  margin: 4px 0;
  font-weight: bold;
`;
